<template>
<div class="chapter">
<div class="inner_page">
<div>
<h1 class="toc-title"><span>Contents</span></h1>
<p class="toc-preface" id="toc-ad-card"><span href="#/adcard" title="Link target outside of Sample">By the Same Author</span></p>
<p class="toc-preface" id="toc-copyright"><span href="#/copyright" title="Link target outside of Sample">Copyright</span></p>
<p class="toc-chapter" id="toc-prologue"><a href="#/prologue">Prologue</a></p>
<p class="toc-part" id="toc-part001"><a href="#/part001">Part One: England, 1651</a></p>
<p class="toc-chapter" id="toc-chapter002"><a href="#/chapter002">Chapter I</a></p>
<p class="toc-chapter" id="toc-chapter003"><span href="#/chapter003" title="Link target outside of Sample">Chapter II</span></p>
<p class="toc-part" id="toc-part002"><span href="#/part002" title="Link target outside of Sample">Part Two: Southern China, Yong-ch’ing Year One …</span></p>
<p class="toc-chapter" id="toc-chapter004"><span href="#/chapter004" title="Link target outside of Sample">Chapter III</span></p>
<p class="toc-chapter" id="toc-chapter005"><span href="#/chapter005" title="Link target outside of Sample">Chapter IV</span></p>
<p class="toc-part" id="toc-part003"><span href="#/part003" title="Link target outside of Sample">Part Three: Place uncertain</span></p>
<p class="toc-chapter" id="toc-chapter006"><span href="#/chapter006" title="Link target outside of Sample">Chapter V</span></p>
<p class="toc-chapter" id="toc-chapter007"><span href="#/chapter007" title="Link target outside of Sample">Chapter VI</span></p>
<p class="toc-chapter" id="toc-chapter008"><span href="#/chapter008" title="Link target outside of Sample">Chapter VII</span></p>
<p class="toc-chapter" id="toc-chapter009"><span href="#/chapter009" title="Link target outside of Sample">Chapter VIII</span></p>
<p class="toc-chapter" id="toc-chapter010"><span href="#/chapter010" title="Link target outside of Sample">Chapter IX</span></p>
<p class="toc-chapter" id="toc-chapter011"><span href="#/chapter011" title="Link target outside of Sample">Chapter X</span></p>
<p class="toc-chapter" id="toc-chapter012"><span href="#/chapter012" title="Link target outside of Sample">Chapter XI</span></p>
<p class="toc-part" id="toc-part004"><span href="#/part004" title="Link target outside of Sample">Part Four: Rodrigues, 1653</span></p>
<p class="toc-chapter" id="toc-chapter013"><span href="#/chapter013" title="Link target outside of Sample">Chapter XII</span></p>
<p class="toc-chapter" id="toc-epilogue"><span href="#/epilogue" title="Link target outside of Sample">Epilogue</span></p>
<p class="toc-acknowledgements" id="toc-acknowledgements"><span href="#/acknowledgements" title="Link target outside of Sample">Acknowledgements</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?28193a97